import { useState } from "react";
import { Star } from "lucide-react";

// Shared UI helper — a row of 5 filled/empty stars for a rating value 1-5.
// If `interactive` is true, calls onChange(value) when user clicks a star.
export const StarRow = ({ value = 5, size = 20, interactive = false, onChange, testIdPrefix = "star" }) => {
  const [hover, setHover] = useState(0);
  const shown = hover || value;
  return (
    <div className="inline-flex items-center gap-0.5" role={interactive ? "radiogroup" : "img"} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= shown;
        const cls = filled ? "text-[#E9C46A]" : "text-[#1D3557]/25";
        return interactive ? (
          <button
            key={i}
            type="button"
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange && onChange(i)}
            className={`transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#E9C46A] rounded ${cls}`}
            aria-label={`Rate ${i} star${i > 1 ? "s" : ""}`}
            data-testid={`${testIdPrefix}-${i}`}
          >
            <Star size={size} fill={filled ? "#E9C46A" : "none"} />
          </button>
        ) : (
          <Star key={i} size={size} className={cls} fill={filled ? "#E9C46A" : "none"} />
        );
      })}
    </div>
  );
};

export default StarRow;
